<template>
  <div>
    <span
      >広告主のレポートを確認できるユーザーを招待する場合、emailを入力してください。</span
    >
    <v-layout v-for="(text, index) in textArray" :key="index" row wrap>
      <v-flex xs11 style="margin-top: 10px;">
        <v-text-field
          ref="arrayText"
          :value="text"
          :placeholder="'メールアドレス' + (index + 1)"
          :disabled="disabled"
          @input="inputText($event, index)"
          @keydown.enter="onPressEnter(index)"
        />
        <div v-if="invalidEmailAddresses.includes(text)" style="display: flex;">
          <small class="red--text">メールアドレスが無効です。</small>
          <v-tooltip bottom open-delay="400">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="primary" class="info-icon" small>
                info
              </v-icon>
            </template>
            <span v-html="emailInfoMessage" />
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex xs1>
        <v-btn
          v-if="index !== 0"
          @click="removeTextField(index)"
          :disabled="disabled"
          color="red"
          fab
          small
          depressed
          outline
        >
          <v-icon color="red" class="v-icon">remove</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-btn
      @click="addTextField"
      :disabled="disabled"
      fab
      dark
      small
      depressed
      color="primary"
    >
      <v-icon class="v-icon" dark>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AddableTextField',
  props: {
    emailAddresses: {
      type: Array,
      default: () => [],
    },
    invalidEmailAddresses: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      textArray: [''],
      emailInfoMessage: `メールアドレスが下記の条件に当てはまる場合、アカウントの登録ができません。<br />
        メールアドレスを修正の上、再度ご登録ください。<br /><br />

        1. ( ) < > [ ] : ; ¥ , が含まれている<br />
        2. @が複数含まれている<br />
        3. ダブルピリオド（..）が含まれている<br />
        4. 先頭がハイフン（-）になっている<br />
        5. @の後にピリオド（.）が含まれていない<br />
        6. 先頭もしくは末尾がピリオド（.）になっている<br />
        7. メールアドレス全体で257文字以上になっている<br />
        8. ラベルの先頭もしくは末尾がハイフン（-）になっている<br />
        9. スペースが含まれている<br />`,
    }
  },
  created() {
    if (this.emailAddresses.length > 0) {
      this.textArray = this.emailAddresses
    }
  },
  methods: {
    inputText(text, index) {
      this.textArray[index] = text
      this.$refs.arrayText[index].focus
      this.$emit('inputText', { text: text, index: index })
    },
    async addTextField() {
      this.textArray.push('')
      const index = this.textArray.length - 1
      await this.$nextTick
      this.$refs.arrayText[index].focus()
    },
    removeTextField(index) {
      this.textArray.splice(index, 1)
    },
    /**
     * 最終行なら追加
     */
    onPressEnter(index) {
      if (index === this.textArray.length - 1) {
        this.addTextField()
        this.$refs.arrayText[index].focus()
      } else {
        this.$refs.arrayText[index + 1].focus()
      }
    },
  },
}
</script>

<style scoped>
.v-text-field >>> .v-text-field__details {
  height: 0px !important;
}
.v-text-field >>> .v-input__slot {
  margin: 0 !important;
}
.v-icon {
  height: initial;
}
.info-icon {
  display: flex;
}
</style>
